import React, { useEffect, useState } from "react";
import { Box, Typography, TextField, IconButton, Paper, InputAdornment } from "@mui/material";
import ArrowCircleRightRoundedIcon from "@mui/icons-material/ArrowCircleRightRounded";
import { Trans } from "@lingui/react/macro";
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { DateTimePicker, DatePicker, LocalizationProvider } from '@mui/x-date-pickers';

type QuestionFieldProps = {
  question: string;
  onSend: (answer: string) => void;
  type?: "text" | "date";
};

const QuestionField: React.FC<QuestionFieldProps> = ({ question, onSend, type = "text" }) => {
  const [answer, setAnswer] = useState("");
  const [open,setOpen] = useState(false);

  const handleSend = () => {
    if (answer.trim()) {
      onSend(answer);
      setAnswer("");
    }
  };

  // useEffect(() => {
  //   if (type === "date" && answer.trim()) {
  //     handleSend();
  //   }
  // }, [answer]);

  return (
    <Paper elevation={0} sx={{ pl: 3, pr: 3 }} style={{ borderRadius: "0" }}>
      <Typography variant="subtitle1" color="primary.main">
        {question}
      </Typography>
      <Box display="flex" alignItems="center" mt={2}>
        { type === "date" ? (
         <LocalizationProvider dateAdapter={AdapterDateFns}>
            <DatePicker
              open={open}
              onOpen={() => setOpen(true)}
              onClose={() => setOpen(false)}
              sx={{ width: '100%', marginBottom: '16px' }}
              format="MM/dd/yyyy"
              slotProps={{
                textField: {
                  variant: "outlined",
                  fullWidth: true,
                  onClick: () => setOpen(true),
                  onKeyPress: (e) => {
                    if (e.key === "Enter" && !e.shiftKey) {
                      e.preventDefault();
                      handleSend();
                    }
                  },
                  InputProps: {
                    onClick: () => {
                      console.log("DatePicker clicked");
                      setOpen(true);
                    },
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton onClick={handleSend} color="primary">
                          <ArrowCircleRightRoundedIcon />
                        </IconButton>
                      </InputAdornment>
                    ),
                  }
                },
              }}
              label={<Trans>Your answer</Trans>}
              value={answer ? new Date(answer) : null}
              onChange={(newValue: Date | null) =>
                newValue && setAnswer(newValue.toISOString())
              }
            />
          </LocalizationProvider>

        ) : (
        <TextField
          fullWidth
          multiline
          variant="outlined"
          value={answer}
          label={<Trans>Your answer</Trans>}
          onChange={(e) => setAnswer(e.target.value)}
          onKeyPress={(e) => {
            if (e.key === "Enter" && !e.shiftKey) {
              e.preventDefault();
              handleSend();
            }
          }}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton onClick={handleSend} color="primary">
                  <ArrowCircleRightRoundedIcon />
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
        )}
      </Box>
    </Paper>
  );
};

export default QuestionField;
